import React from 'react';
import CommentComponent from '../../components/Comment/CommentComponent';
import TabComponent from '../../components/TabComponent';

class CommentsTab extends TabComponent {
  constructor(props) {
    super(props);

    this.meta.id = 'page-execution-test-result-details-comment';
    this.meta.title = document.title;
  }

  render() {
    const { teamId, projectId, objectId, objectType, executionId } = this.props;
    return (
      <>
        <CommentComponent
          teamId={teamId}
          projectId={projectId}
          objectId={objectId}
          objectType={objectType}
          executionId={executionId}
        />
      </>
    );
  }
}

export default CommentsTab;
